module.exports = __webpack_public_path__ + "img/articles.9ae448a2.jpg";